<template>
  <div
    v-if="showComp"
    :class="[
      'motorway-valuation-wrapper',
      { 'motorway-valuation-wrapper--last': isLast },
    ]"
  >
    <current-vehicle-valuation
      :header="valuationHeader"
      :subheader="valuationSubHeader"
      :guidePriceText="guidePriceText"
      :disclaimerText="disclaimerText"
    />
    <motorway-component
      :header="motorwayHeader"
      :subheader="motorwaySubHeader"
      :benefits="benefits"
      :motorwayBenefitsHeader="benefitsHeader"
      :buttonText="buttonText"
      :isLast="isLast"
      :link="link"
    />
  </div>
</template>

<script lang='ts'>
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CurrentVehicleValuationComponent from '../vehicle/CurrentVehicleValuationComponent.vue';
import MotorwayComponent from './MotorwayComponent.vue';

const EnquiryModule = namespace('enquiryModule');

@Component({
  components: {
  'current-vehicle-valuation': CurrentVehicleValuationComponent,
  'motorway-component': MotorwayComponent
  }
  })
export default class MotorwayValuationWrapperComponent extends Vue {
  @EnquiryModule.Getter public extraData;

  @Prop(String)
  public valuationHeader!: string;

  @Prop(String)
  public motorwayHeader!: string;

  @Prop(String)
  public valuationSubHeader!: string;

  @Prop(String)
  public motorwaySubHeader!: string;

  @Prop(String)
  public guidePriceText!: string;

  @Prop(String)
  public disclaimerText!: string;

  @Prop(Array)
  public benefits!: string[];

  @Prop(String)
  public benefitsHeader!: string;

  @Prop(String)
  public buttonText!: string;

  @Prop({ default: false })
  public isLast!: boolean;

  @Prop(String)
  public link!: string;

  public get showComp(): boolean {
    const vrm = this.extraData.find(
      (x) => x.keyName === 'PartExchangeRegistration'
    );

    if (vrm) {
      return true;
    }

    return false;
  }
}
</script>
